'use strict';

/**
 * @classname AnchorFaqAccordion
 * @classdesc カテゴリーアコーディオン
 */
export default class AnchorFaqAccordion {
	/**
	 * @constructor
	 * @param {jQuery} $e - .anchor--pickup-question
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._$target = $e.next('.block--pickup-answer');
		$e.on('click', () => this.onClick());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof AnchorFaqAccordion
	 * @return undefined
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		const $pickupQuestion = $('.list--pickup-faq .anchor--pickup-question');
		const $pickupAnswer = $('.list--pickup-faq .block--pickup-answer');
		$pickupQuestion.each((idx, e) => {
			const $e = $(e);
			if($e.hasClass('open')) $e.removeClass('open').addClass('close');
		});
		if(!this._$target.hasClass('open')){
			$pickupAnswer.removeClass('open').addClass('close');
			this._$e.addClass('open').removeClass('close');
			this._$target.slideDown().addClass('open').removeClass('close');
		}else{
			this._$e.removeClass('open').addClass('close');
			this._$target.slideUp().removeClass('open').addClass('close');
		}
		$pickupAnswer.each((idx, e) => {
			const $e = $(e);
			if(!$e.hasClass('open')) $e.slideUp();
		});
	};
};
